import { render, staticRenderFns } from "./InputTable.vue?vue&type=template&id=012619eb&"
import script from "./InputTable.vue?vue&type=script&lang=js&"
export * from "./InputTable.vue?vue&type=script&lang=js&"
import style0 from "./InputTable.vue?vue&type=style&index=0&id=012619eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports